import DarkModeToggle from "../../interface/DarkModeToggle";

function General() {
  return (
    <div>
      Dark Mode Toggle
      <span>
        <DarkModeToggle />
      </span>
    </div>
  );
}

export default General;
